export default (params) => ({
  trigger: {
    name: 'product_trade_in.show',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'not_recognized',
          'recognized',
        ],
      },
    },
    event: {
      name: 'show_content',
    },
    nonInt: true,
  },
});
